import React, { Component } from 'react';
import label from './labelwithbow.png';
import gingerman from './gingerman.png';
import add from './add.png';
import remove from './delete.png';
import beard from './beardmini.png';
import done from './cone.png';
import './App.css';

function Participant(props) {
  return (
    <div className="App-singleparticipant">
      <div className="App-profileimage">
          <img src={beard} className="App-picture" alt="profile" />
      </div>
      <div className="App-profiledata">
        <div className="App-nickname">
          <label>Name or Nickname</label>
          <input type="text" required value={props.name}/>
        </div>
        <div className="App-email">
          <label>Email</label>
          <input type="Email" required value={props.email}/>
        </div>
      </div>
      <div className="App-closebutton" onClick={() => props.onRemove(props.id)}>
        <img src={remove} className="App-delete" alt="delete button"/>
      </div>
    </div>
  );
}

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      lastId: 0,
      participants: [{
        id: 0,
        name: 'Hrvica',
        email: 'hrvoje.bandov@gmail.com',
      }],
    }
  }

  render() {

    let bozic = new Date(2016, 11, 25);

    return (
      <div className="App">
        <div className="App-header">
        </div>

        <div className="App-intro">
          <div className="App-logodiv">
            <h1>Secret Santa</h1>
          </div>
        </div>
        <div className="App-description">
          <p className="App-descriptiontext">
          <span className="App-descriptiontextbig">This is a free Secret
           Santa gift exchange organizer!</span><br/>
          Use this page to pair your friends, family or co-workers
          for a Secret Santa gift exchange event!
          </p>
        </div>

        <div className="App-main">
          <div className="App-mainInnerDiv">
            <img src={label} className="App-labelwithbow" alt="rules"/>

                    <div className="App-participants">
                      <div className="App-participantsInner">
                        {
                          this.state.participants.map(p => (
                            <Participant key={p.id} {...p}
                               onRemove={this.handleRemoveParticipant} />
                          ))
                        }
                        <div className="App-addbutton" onClick={this.handleAddParticipant}>
                          <img src={add} className="App-addbuttonimg" alt="add button"/>
                          <div>Add more participants</div>
                        </div>
                        <div className="App-donebutton">
                          <img src={done} className="App-donebuttonimg" alt="done button"/>
                          <div>Done</div>
                        </div>
                      </div>
                    </div>
          {/*<ul className="App-rulesText">
            <li> Create a list of participants </li>
            <li> Make rules (Olive can&apos;t pick Rudolph) </li>
            <li> Let them know who they are giving a present to</li>
          </ul>*/}
          </div>
        </div>

        <div className="gingerman">
          <div className="App-countdown">
            <p>
            <span className="App-days">
              { Math.ceil((bozic - new Date()) / 1000 / 3600 / 24) }
            </span>
            <br/>days til Christmas!
            </p>
          </div>
          <img src={gingerman} className="App-gingerman" alt="gingerman" />
        </div>
        <div className="App-footer">
          <p>Copyright by Lelisine 2016</p>
        </div>
      </div>
    );
  }

  handleAddParticipant = () => {
    const lastId = this.state.lastId,
          participants = [...this.state.participants];

    participants.push({
      id: lastId + 1,
      name: '',
      email: '',
    });

    this.setState({
      lastId: lastId + 1,
      participants: participants,
    })
  }

  handleRemoveParticipant = (id) => {
    const participants = [...this.state.participants],
          index = participants.find(e => e.id === id);

    participants.splice(index, 1);

    this.setState({participants});
  }

}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/